import React, { useContext, useEffect, useState, useRef, useCallback, useMemo, forwardRef } from 'react';
import Icon, { DownOutlined, UpOutlined, UserOutlined, LoadingOutlined, CloseCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, DatePicker, Input, Modal, Spin, Tooltip } from 'antd';
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from '../../services/api'
import { displayMessage } from '../../services/helper';
import { DateTime } from 'luxon';
import moment from 'moment';
import styles from '../../services/styles';
import EEventTypes from '../../patients/enums/EEventTypes';
// emojis
import smile_emoji from '../../assets/smile_emoji.png'
import neutral_emoji from '../../assets/neutral_emoji.png'
import sad_emoji from '../../assets/sad-emojo.png'
import full_star from '../../assets/full_star.png'
import half_star from '../../assets/half_star.png'
import blank_star from '../../assets/blank_star.png'
import { MultiSelect } from '../../components/selects/MultiSelect';
import ListControlFilters from '../../components/filters/ListControlFilters';
import ListControlDetailModal from './ListControlDetailModal';
import { Block } from '@material-ui/icons';
const { bc9, bc10 } = styles

// SVGs:
const FilterIcon = ({ width = 28, height = 28, fill = 'currentColor' }) => (
    <svg width={width} height={height} viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
        <path 
            fillRule="evenodd" 
            clipRule="evenodd" 
            d="M8.69575 6.89938L13.9111 0.628129C14.006 0.514626 14.0265 0.355953 13.965 0.22106C13.9029 0.0861633 13.7699 0 13.6235 0H0.376485C0.230051 0 0.0970863 0.0861678 0.0350077 0.22106C-0.0264951 0.355956 -0.00599414 0.514625 0.0888961 0.628129L5.30425 6.89938C5.36341 6.96831 5.39504 7.05805 5.39269 7.15015V13.804C5.39094 13.8789 5.43252 13.9478 5.49871 13.9805C5.56548 14.0138 5.64456 14.0037 5.70138 13.9561L8.60723 11.5345V7.15015C8.60489 7.05804 8.63659 6.96831 8.69575 6.89938Z" 
            fill={fill}
        />
    </svg>
)
const CalendarIcon = ({ width = 28, height = 28, fill = 'currentColor' }) => (
    <svg width={width} height={height} viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
            d="M12.9092 1.09091H12.3637V0H11.2728V1.09091H3.63645V0H2.54554V1.09091H2.00009C1.40009 1.09091 0.90918 1.58182 0.90918 2.18182V10.9091C0.90918 11.5091 1.40009 12 2.00009 12H12.9092C13.5092 12 14.0001 11.5091 14.0001 10.9091V2.18182C14.0001 1.58182 13.5092 1.09091 12.9092 1.09091Z" 
            fill={fill}
        />
    </svg>
)
const MangosIcon = ({ width = 28, height = 28, fill = 'currentColor' }) => (
    <svg width={width} height={height}  viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
            fillRule="evenodd" 
            clipRule="evenodd" 
            d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM11.4316 11.1626V4.96562H9.65728L7.9359 9.25583L6.19687 4.96562H4.4137V11.1626H5.92321V7.43735L7.31797 11.1626H8.53618L9.92211 7.44618V11.1626H11.4316ZM7.31934 13.3333V11.4609H8.53919V13.3333H7.31934ZM8.53919 2.97878H7.31934V6.85719L7.92927 7.90886L8.53919 6.85719V2.97878Z" 
            fill={fill}
        />
    </svg>
)
const CloackIcon = ({ width = 28, height = 28, fill = 'currentColor' }) => (
    <svg width={width} height={height}  viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
            fillRule="evenodd" 
            clipRule="evenodd" 
            d="M6.66162 12.8254C9.97533 12.8254 12.6616 10.1391 12.6616 6.82544C12.6616 3.51173 9.97533 0.825439 6.66162 0.825439C3.34791 0.825439 0.661621 3.51173 0.661621 6.82544C0.661621 10.1391 3.34791 12.8254 6.66162 12.8254ZM7.03662 3.39688C7.03662 3.18977 6.86873 3.02188 6.66162 3.02188C6.45451 3.02188 6.28662 3.18977 6.28662 3.39688V6.82545V7.39416L6.80934 7.17013L9.80934 5.88442C9.9997 5.80283 10.0879 5.58238 10.0063 5.39202C9.92472 5.20166 9.70426 5.11348 9.5139 5.19506L7.03662 6.25675V3.39688Z" 
            fill={fill}
        />
    </svg>
)
const PersonIcon = ({ width = 28, height = 28, fill = 'currentColor' }) => (
    <svg width={width} height={height}  viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1.48193" y="10.0542" width="9.16667" height="3.33333" fill={fill}/>
        <path d="M9.18538 9.38696H9.3867C10.2527 9.38696 10.9833 10.0319 11.0907 10.8912L11.3142 12.6795C11.3996 13.3628 10.8668 13.9664 10.1782 13.9664H2.46826C1.77964 13.9664 1.24684 13.3628 1.33225 12.6795L1.55578 10.8912C1.66321 10.0319 2.39374 9.38696 3.25981 9.38696H3.4611" stroke={fill} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M6.32307 7.40884C7.90379 7.40884 9.18521 6.12742 9.18521 4.54671C9.18521 2.96599 7.90379 1.68457 6.32307 1.68457C4.74236 1.68457 3.46094 2.96599 3.46094 4.54671C3.46094 6.12742 4.74236 7.40884 6.32307 7.40884Z" fill={fill} stroke={fill} strokeWidth="1.66667"/>
    </svg>
)
const RobotIcon = ({ width = 28, height = 28, fill = 'currentColor' }) => (
    <svg width={width} height={height}   viewBox="0 0 21 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.952637 8.46564C0.952637 7.55978 1.68698 6.82544 2.59283 6.82544V10.1058C1.68698 10.1058 0.952637 9.37149 0.952637 8.46564Z" fill={fill}/>
    <path d="M10.7939 0.264648C11.6997 0.264648 12.4341 0.99899 12.4341 1.90485L9.15369 1.90485C9.15369 0.99899 9.88803 0.264648 10.7939 0.264648Z" fill={fill}/>
    <path d="M20.6348 8.46576C20.6348 9.37162 19.9004 10.106 18.9946 10.106L18.9946 6.82556C19.9004 6.82556 20.6348 7.5599 20.6348 8.46576Z" fill={fill}/>
    <path fillRule="evenodd" clipRule="evenodd" d="M4.23291 5.54517C4.23291 4.4406 5.12834 3.54517 6.23291 3.54517H15.3545C16.4591 3.54517 17.3545 4.4406 17.3545 5.54517V11.3864C17.3545 12.4909 16.4591 13.3864 15.3545 13.3864H6.23291C5.12834 13.3864 4.23291 12.4909 4.23291 11.3864V5.54517ZM9.1535 8.46577C9.1535 9.37163 8.41916 10.106 7.51331 10.106C6.60745 10.106 5.87311 9.37163 5.87311 8.46577C5.87311 7.55991 6.60745 6.82557 7.51331 6.82557C8.41916 6.82557 9.1535 7.55991 9.1535 8.46577ZM14.0741 10.106C14.98 10.106 15.7143 9.37163 15.7143 8.46577C15.7143 7.55991 14.98 6.82557 14.0741 6.82557C13.1683 6.82557 12.434 7.55991 12.434 8.46577C12.434 9.37163 13.1683 10.106 14.0741 10.106Z" fill={fill}/>
    </svg>
)
const PresenceIcon = ({ width = 28, height = 28, fill = 'currentColor' }) => (
    <svg width={width} height={height} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
            d="M5.13228 0C2.47196 0 0.306885 2.16508 0.306885 4.8254C0.306885 7.48571 2.47196 9.65079 5.13228 9.65079C7.7926 9.65079 9.95768 7.48571 9.95768 4.8254C9.95768 2.16508 7.7926 0 5.13228 0ZM8.41101 5.38794C8.07577 6.91429 6.69673 8.02159 5.13228 8.02159C3.56784 8.02159 2.18879 6.91429 1.85355 5.38667C1.84466 5.34476 1.85736 5.30032 1.88784 5.26984C1.91831 5.23937 1.96276 5.22667 2.00593 5.23556C3.45863 5.56444 5.11577 5.56825 5.13228 5.56825C5.14879 5.56825 6.8072 5.56445 8.25863 5.23683C8.30181 5.22667 8.34498 5.23937 8.37673 5.27111C8.40847 5.30159 8.42117 5.34603 8.41101 5.38794Z" 
            fill={fill}
        />
    </svg>
)
const ChartIcon = ({ width = 28, height = 28, fill = 'currentColor' }) => (
    <svg width={width} height={height}  viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1123_3040)"> {/* ✅ Fixed clip-path */}
            <rect x="1.0459" y="7.60303" width="3" height="5" rx="1.5" fill={fill} />
            <rect x="9.0459" y="0.603027" width="3" height="12" rx="1.5" fill={fill} />
            <rect x="5.0459" y="3.60303" width="3" height="9" rx="1.5" fill={fill} />
        </g>
        <defs>
            <clipPath id="clip0_1123_3040">
                <rect width="12" height="12" fill="white" transform="translate(0.0458984 0.603027)" /> {/* ✅ Keep this "white" or "none" */}
            </clipPath>
        </defs>
    </svg>
)
const ColorLineIcon = ({ width = 28, height = 28, fill = 'currentColor' }) => (
    <svg width={width} height={height}  viewBox="0 0 6 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.314941" y="0.825439" width="5" height="24" rx="2.5" fill={fill}/>
    </svg>
)
const PlusIcon = ({ width = 28, height = 28, fill = 'currentColor' }) => (
    <svg width={width} height={height}  viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.904541" width="20" height="20" rx="10" fill={fill}/>
    <path d="M10.3999 5.40454L10.3999 16.4045" stroke="#01ACD2" strokeWidth="2" strokeLinecap="round"/>
    <path d="M15.8999 10.9045L4.8999 10.9045" stroke="#01ACD2" strokeWidth="2" strokeLinecap="round"/>
    </svg>
)
const UnCheckedIcon = ({ width = 28, height = 28, fill = 'currentColor' }) => (
    <svg width={width} height={height}  viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="6" r="6" fill={fill}/>
    <circle cx="6" cy="6" r="4.5" fill="white" stroke="white"/>
    </svg>
)
const CheckedIcon = ({ width = 28, height = 28, fill = 'currentColor' }) => (
    <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="6" cy="6" r="6" fill={fill}/>
    <circle cx="6" cy="6" r="4.5" stroke="white"/>
    </svg>
)

const maxRequesterForFilter = 10

export default function ListControl() {
    const {setShowLoading,mobile_mode, show_loading} = useContext(GeneralContext)

    const [controlsGroups, setControlsGroups] = useState([])
    const [isFilterModalOpen, setIsFilterModalOpen] = useState(false)
    const [etapas, setEtapas] = useState([])
    const [orderByScore, setOrderByScore] = useState(false)
    const [orderByFrequency, setOrderByFrequency] = useState(false)

    const [isControlDetailModalOpen, setIsControlDetailModalOpen] = useState(false)
    const [detailModalShowExercise, setDetailModalShowExercise] = useState(false)
    const [monitoryEvents, setMonitoryEvents] = useState([])
    const [exerciseEvents, setExerciseEvents] = useState([])
    const [exerciseSections, setExerciseSections] = useState([])
    const [monitorySections, setMonitorySections] = useState([])
    const [currentFilters, setCurrentFilters] = useState({})
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPagesCount, setTotalPagesCount] = useState(1)

    // Refs evitam closure desatualizada no scroll/paginação (by_frequency / by_score)
    const currentFiltersRef = useRef(currentFilters)
    const currentPageRef = useRef(currentPage)
    const orderByFrequencyRef = useRef(orderByFrequency)
    const orderByScoreRef = useRef(orderByScore)
    const showLoadingRef = useRef(show_loading)
    const totalPagesCountRef = useRef(totalPagesCount)

    currentFiltersRef.current = currentFilters
    currentPageRef.current = currentPage
    orderByFrequencyRef.current = orderByFrequency
    orderByScoreRef.current = orderByScore
    showLoadingRef.current = show_loading
    totalPagesCountRef.current = totalPagesCount

    const loadControlsData = useCallback(async (extraFilters = {}, append = false, fromFilter = false) => {
        showLoadingRef.current = true
        setShowLoading(true)
        try {
            const limit_per_page = 10
            let page = append ? currentPageRef.current + 1 : 1
            if (fromFilter) { extraFilters = {...extraFilters, page} }
            // extraFilters por último para o clique de ordenação sobrescrever os flags
            let payload = {
                ...currentFiltersRef.current,
                page,
                by_frequency: orderByFrequencyRef.current,
                by_score: orderByScoreRef.current,
                ...extraFilters,
                limit: limit_per_page
            }

            if (payload?.days_group && payload.days_group?.length > 0) {
                const today = DateTime.now().endOf('day')
                payload.end_date =  today.toFormat("yyyy-MM-dd")
                payload.start_date =  today.minus(  {'days': payload.days_group[0]}).toFormat("yyyy-MM-dd")
            }
            else{
                if (moment.isMoment(payload.start_date)) {
                    payload.start_date = payload.start_date.format("YYYY-MM-DD")
                }
                if (moment.isMoment(payload.end_date)) {
                    payload.end_date = payload.end_date.format("YYYY-MM-DD")
                }
            }
            const patient_ids = payload?.patients_selected ? payload.patients_selected.map(e=>e.value) :[]
            const rs = await api.dialy_controls.listControlGrouped({...payload, patient_ids})
            setControlsGroups(prev => append ? [...prev, ...rs.data.groups] : rs.data.groups)
            setTotalPagesCount(rs.data.total_pages)
            totalPagesCountRef.current = rs.data.total_pages
            // Mantém currentFilters só com filtros de busca (sem page/limit/ordenação)
            const { page: _page, limit: _limit, by_frequency: _byFrequency, by_score: _byScore, ...filtersToKeep } = payload
            setCurrentFilters(filtersToKeep)
            currentFiltersRef.current = filtersToKeep
            if (append) {
                setCurrentPage(page);
                currentPageRef.current = page
            } else {
                setCurrentPage(1);
                currentPageRef.current = 1
            }
        } finally {
            showLoadingRef.current = false
            setShowLoading(false)
        }
    }, [setShowLoading])

    const lastControlRef = useRef(null);
    const loadNextPage = useCallback(() => {
        if (currentPageRef.current < totalPagesCountRef.current && !showLoadingRef.current) {
            loadControlsData({}, true); // Load next page of controls
        }
    }, [loadControlsData]);
    // Scroll to the last ControlCard whenever the controlsGroups change
    const handleScrollToLastControl = () => {
        if (lastControlRef.current) {
            lastControlRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }

    const firstControlRef = useRef(null);

    // Scroll to the first control
    const handleScrollToFirstControl = ({is_auto = false}) => {
        if (firstControlRef.current) {
            firstControlRef.current.scrollIntoView({ behavior: is_auto ? 'auto' :'smooth' });
        }
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                const entry = entries[0];
                if (entry.isIntersecting) {
                    loadNextPage();
                }
            }, 
            {
                rootMargin: '0px 0px 200px 0px',
                threshold: 0.1
            }
        );

        const observe = () => {
            if (lastControlRef.current) {
                observer.observe(lastControlRef.current);
            }
        };

        const unobserve = () => {
            if (lastControlRef.current) {
                observer.unobserve(lastControlRef.current);
            }
        };

        observe();

        const handleResize = () => {
            unobserve();
            observe();
        };

        window.addEventListener('resize', handleResize);

        return () => {
            unobserve();
            window.removeEventListener('resize', handleResize);
            observer.disconnect();
        };
    }, [loadNextPage, controlsGroups]);


    const defaultStartDate = DateTime.now().startOf('day').minus( {days: 15} ).toJSDate()
    const defaultEndDate = DateTime.now().endOf('day').toJSDate()

    useEffect(
        () => {
            loadControlsData({
                start_date: moment(defaultStartDate).format('YYYY-MM-DD'),
                end_date: moment(defaultEndDate).format('YYYY-MM-DD'),
            })
            getColorConfigs()
            setCurrentFilters({
                ...currentFilters,
                start_date: moment(defaultStartDate).format('YYYY-MM-DD'),
                end_date: moment(defaultEndDate).format('YYYY-MM-DD'),
            })
        },[]
    )
    const getColorConfigs = async () =>{
        try {
            const res = await api.config.getRuleConfig()
            const etapas = JSON.parse(res.data[0].rule_for_time_bar)?.etapas
            setEtapas(etapas)
        } catch (error) {
            console.log(error)
        }
    }
    function ColorScore ({color_scores, score, is_emoji = false, is_start = false}) {
        const smile_emoji_min = 3
        const neutral_emoji_min = 2
        const targetEmoji = (is_emoji ?  
            score >= smile_emoji_min ? smile_emoji :
                score >=  neutral_emoji_min ? neutral_emoji :
                sad_emoji
        : null)

        const max_star_score = 3
        return(
            <div style={{display: 'flex', flexDirection: 'row'}}>
                {
                    is_emoji &&
                    <img
                      width={'22px'}
                      style={{ marginLeft: '12px', margin: 0, padding: 0 }}
                      src={targetEmoji}
                    />

                }
                {
                    !is_emoji && is_start &&
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                            <img width={mobile_mode ? '14px': '16px'} style={{ marginLeft: '12px', margin: 0, padding: 0 }} src={
                                score >= (max_star_score * (4/6)) ? full_star : (score >= (max_star_score * (3/6)) ? half_star : blank_star)
                            } />
                            <div style={{display: 'flex', flexDirection: 'row', gap: 5}}>
                                <img width={mobile_mode ? '14px': '16px'} style={{ marginLeft: '12px', margin: 0, padding: 0 }} src={
                                    score >= (max_star_score * (2/6)) ? full_star : (score >= (max_star_score * (1/6)) ? half_star : blank_star)
                                } />
                                <img width={mobile_mode ? '14px': '16px'} style={{ marginLeft: '12px', margin: 0, padding: 0 }} src={
                                    score >= max_star_score ? full_star : (score >= (max_star_score * (5/6)) ? half_star : blank_star)
                                } />
                            </div>
                        </div>
                }
                {
                    !is_emoji && !is_start && color_scores && color_scores.length > 0 &&
                        color_scores.map((e,index) => (
                            <div key={index}>
                                <ColorLineIcon width={8} height={25} fill={score>= e?.min_score ? e?.color : 'gray'}/>
                            </div>
                        ))
                }
            </div>
        )
    }
    const ControlCard = forwardRef(({ info }, ref) => {
        const color_scores = useMemo(() => 
            etapas.map(e => ({
                min_score: e?.ordem,
                color: `rgb(${e.cor_rgb[0]}, ${e.cor_rgb[1]}, ${e.cor_rgb[2]})`
            })), [etapas]);

        const createdDate = DateTime.fromISO(info?.patient_createdat)
        const todayDate = DateTime.utc()
        const daysPassed = Math.floor(todayDate.diff(createdDate, 'days').days)
        const monthsPassed = Math.floor(todayDate.diff(createdDate, 'months').months)
        const yearsPassed = Math.floor(todayDate.diff(createdDate, 'years').years)
        const formattedTimePassed = yearsPassed>0 ? `${yearsPassed} A` : (monthsPassed>0 ? `${monthsPassed} M` : `${daysPassed || 0} D`)

        const totalSeconds = parseFloat(info?.total_duration) / parseFloat(info?.total_controls)
        const minutes = Math.floor(totalSeconds / 60)
        const seconds = Math.round(totalSeconds % 60)
        const totalMinutes = minutes + seconds / 60
        let durationFormatted
        if (totalMinutes < 1) {
          durationFormatted = `${Math.round(totalSeconds)} sec/dia`
        } else if (totalMinutes < 60) {
          durationFormatted = `${Math.round(totalMinutes)} min/dia`
        } else {
          durationFormatted = `${(totalMinutes / 60).toFixed(0)} h/dia`
        }

        const monitoryRating = Math.floor(info?.avg_monitory_rating || 0)

        const monitoryStage = Math.floor(currentFilters.score ? info?.performance_monitory_stage : info?.avg_monitory_stage || 0)
        const monitoryStars = info?.avg_monitory_stars || 0
        const exerciseRating = Math.floor(info?.avg_exercise_rating || 0)
        const exerciseStage = Math.floor(info?.avg_exercise_stage || 0)
        const exerciseStars = info?.avg_exercise_stars || 0

        const percent_missing = (100 - parseFloat(info?.missing_sync_percentage)).toFixed(0)
        const percent_missing_exercise = parseInt((100 - parseFloat(info?.missing_exercise_percentage)).toFixed(0))
        const percent_missing_monitory = parseInt((100 - parseFloat(info?.missing_monitory_percentage)).toFixed(0))

        const [tabSelected, setTabSelected] = useState([])
        const [controls, setControls] = useState([])
        const [tabIsLoading, setTabIsLoading] = useState(false)
        const [neverOpenTabs, setNeverOpenTabs] = useState(true)

        const handleOpentab = async (tab_id) => {

            setTabIsLoading(true)
            try {
                if (tabSelected.includes(tab_id)) {
                    setTabSelected([])                    
                } else (
                    setTabSelected([tab_id])
                )
                if (neverOpenTabs) {
                    setNeverOpenTabs(false)
                    const res = await api.control.listControlsTabs({control_ids: info?.control_ids})
                    setControls(res.data)
                }
            } catch (error) {
                console.log(error)
            } finally {
                setTabIsLoading(false)
            }
        }
        return(<div ref={ref} style={{display: 'flex', flexDirection: 'column', borderRadius: '20px', backgroundColor: bc9, marginLeft: mobile_mode ? 0 : 10, marginRight: mobile_mode ? 0 : 10, minWidth: mobile_mode ? '100%' : 520, boxShadow: '4px 8px 8px rgba(10, 10, 10, 0.5)'}} >
            {/* Dados do paciente e dentista */}
            <div style={{display: 'flex', width: '100%', flexDirection: mobile_mode ? 'column' : 'row', paddingTop: 10, paddingRight: 5, paddingLeft: 5}}>
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    {info?.Patient?.image_url ? (
                        <img src={info?.patient_image_url} alt="Patient" style={{ height: 40, width: 40, borderRadius: "50%" }} />
                    ) : (
                        <UserOutlined style={{ fontSize: 40, color: "#ccc" }} />
                    )}
                    <div style={{display: 'flex', flex: 1, flexDirection: 'column', marginLeft: '10px', color: 'white'}}>
                        <div style={{display: 'flex', flex:1, fontWeight: 'bold', alignItems: 'center', fontSize: 16, maxWidth:300, overflow: 'hidden',textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{`${info?.patient_first_name || ""} ${info?.patient_last_name || ""}`}</div>
                        <div style={{display: 'flex', flex:1, fontWeight: 'normal', alignItems: 'center', fontSize: 12, maxWidth:300, overflow: 'hidden',textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{`${info?.dentist_first_name || ""} ${info?.dentist_last_name || ""}`}</div>
                    </div>
                </div>
                <div style={{display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'stretch', justifyContent: 'flex-end', color: 'white', gap: '8px'}}>
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', borderColor: 'white', borderRadius: 20, borderWidth:1, paddingLeft: 8, paddingRight: 8, gap: '5px'}}>
                        <CalendarIcon width={24} height={24} fill={'white'} />
                        <p style={{margin: 0, padding: 0, fontSize: 16, fontWeight: 'bold'}}>{formattedTimePassed}</p>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', borderColor: 'white', borderRadius: 20, borderWidth:1, paddingLeft: 8, paddingRight: 8, gap: '5px'}}>
                        {/* Increase the size of this antd icon */}
                        <MangosIcon width={24} height={24} fill={'white'} />  
                        <p style={{margin: 0, padding: 0, fontSize: 16, fontWeight: 'bold'}}>{info?.total_mangos || '0'}</p>
                    </div>
                </div>
                
            </div>
            {/* Dados de monitorias */}
            <div style={{display: 'flex', flex:1, padding: 10, maxHeight: 60}}>
                <div style={{ backgroundColor: 'white', display: 'flex', flex: 1, padding: 10, borderRadius: 20, gap: mobile_mode ? 3 : 10, alignItems: 'center', justifyContent: 'space-between'}}>
                    <div className='flex w-[55%] justify-between'>
                        <p style={{flex: 1, margin: 0, paddingLeft: 0, fontWeight: 'bold', fontSize: mobile_mode ? 12 : 20}}> {displayMessage("MONITORY")}</p>
                        <div style={{flex: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3, fontSize: mobile_mode ? 14 : 20, paddingLeft: mobile_mode ? 0 : 10}}>
                          <CloackIcon width={mobile_mode ? 14 : 20} height={mobile_mode ? 14 : 20} fill={'black'} />
                          {durationFormatted}
                        </div>
                    </div>
                    <div className='flex flex-1'>
                        <Tooltip title={displayMessage('AVG_PATIENT_RATING_TOOLTIP')}>
                            <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3, fontSize: mobile_mode ? 14 : 20}}>
                                <PersonIcon width={mobile_mode ? 14 : 20} height={mobile_mode ? 14 : 20} fill={'black'} />
                                <ColorScore color_scores={color_scores} score={monitoryRating} is_emoji={true}/>
                            </div>
                        </Tooltip>
                        <Tooltip title={displayMessage('AVG_PATIENT_STAGE_TOOLTIP')}>
                            <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3, paddingRight: mobile_mode ? 2 : 10, fontSize: mobile_mode ? 14 : 20}}>
                                <RobotIcon width={mobile_mode ? 16 : 22} height={mobile_mode ? 16 : 22} fill={'black'} />
                                <ColorScore color_scores={color_scores} score={monitoryStage} />
                            </div>
                        </Tooltip>                        
                        <Tooltip title={displayMessage('AVG_ATTENDANCE_TOOLTIP')}>
                        <div style={{minWidth: 88, paddingLeft: 8, flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 3, paddingRight: mobile_mode ? 2 : 10, backgroundColor: percent_missing_exercise ? '#3FD779' : 'red', borderRadius: '20px', fontSize: mobile_mode ? 14 : 20}}>
                                <PresenceIcon width={mobile_mode ? 10 : 15} height={mobile_mode ? 10 : 15} fill={'white'} />
                                {`${percent_missing_monitory  || "0" }%`}
                            </div>
                        </Tooltip>
                    </div>
                </div>
            </div>
            {/* Dados de exercícios */}
            <div style={{display: 'flex', flex:1, padding: 10, maxHeight: 60}}>
                <div style={{ backgroundColor: 'white', display: 'flex', flex: 1, padding: 10, borderRadius: 20, gap: mobile_mode ? 3 : 10, alignItems: 'center', justifyContent: 'space-between'}}>
                    <div className='flex w-[55%] justify-start'>
                        <p style={{flex: 1, margin: 0, paddingLeft: mobile_mode ? 0 : 10, fontWeight: 'bold', fontSize: mobile_mode ? 12 : 20}}> {displayMessage("EXERCISE")}</p>
                    </div>
                    <div className='flex flex-1'>
                        <Tooltip title={displayMessage('EXERCISE_AVG_PATIENT_RATING_TOOLTIP')}>
                            <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3, fontSize: mobile_mode ? 14 : 20}}>
                                <PersonIcon width={mobile_mode ? 14 : 20} height={mobile_mode ? 14 : 20} fill={'black'} />
                                <ColorScore color_scores={color_scores} score={exerciseRating}  is_emoji={true}/>
                            </div>
                        </Tooltip>
                        <Tooltip title={displayMessage('EXERCISE_AVG_PATIENT_STAGE_TOOLTIP')}>
                            <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3, paddingRight: mobile_mode ? 2 : 10, fontSize: mobile_mode ? 14 : 20}}>
                                <RobotIcon width={mobile_mode ? 16 : 22} height={mobile_mode ? 16 : 22} fill={'black'} />
                                <ColorScore color_scores={color_scores} score={exerciseStars} is_start={true}/>
                            </div>
                        </Tooltip>
                        <Tooltip title={displayMessage('EXERCISE_AVG_ATTENDANCE_TOOLTIP')}>
                        <div style={{minWidth: 88, paddingLeft: 8, flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 3, paddingRight: mobile_mode ? 2 : 10, backgroundColor: percent_missing_exercise ? '#3FD779' : 'red', borderRadius: '20px', fontSize: mobile_mode ? 14 : 20}}>
                            <PresenceIcon width={mobile_mode ? 10 : 15} height={mobile_mode ? 10 : 15} fill={'white'} />
                            {`${percent_missing_exercise  || "0" }%`}
                        </div>
                        </Tooltip>
                    </div>
                </div>
            </div>
            {/* Tabs de listagem de exercícios e monitorias */}
            <div style={{display: 'flex', flex:1, padding: 10, flexDirection: 'column'}}>
                <div style={{display: 'flex', width: '100%', flexDirection: 'row', justifyContent: 'space-evenly', gap: 10, marginBottom: 10}}>
                    <Button 
                        onClick={()=>handleOpentab(1)}
                        style={{
                            display: 'flex', flex: 1, borderRadius: '20px', flexDirection: 'row', justifyContent: 'space-between', 
                            backgroundColor: tabSelected.includes(1) ? 'white' : bc9,
                            color: tabSelected.includes(1) ? bc9 : 'white',
                            borderWidth:2,
                            borderColor: tabSelected.includes(1) ? bc9 : 'white',
                        }}
                        type='primary'
                    > 
                        <div style={{display:  'flex', flex: 2, alignItems: 'center', justifyContent: 'flex-end'}}>
                            {displayMessage("MONITORIES")}
                        </div>
                        <div style={{display:  'flex', flex: 1, alignItems: 'center', justifyContent: 'flex-end'}}>
                            { tabSelected.includes(1) ? <UpOutlined/> : <DownOutlined />}
                        </div>
                    </Button>
                    <Button 
                        onClick={()=>handleOpentab(2)}
                        style={{
                            display: 'flex', flex: 1, borderRadius: '20px', flexDirection: 'row', justifyContent: 'space-between', 
                            backgroundColor: tabSelected.includes(2) ? 'white' : bc9,
                            color: tabSelected.includes(2) ? bc9 : 'white',
                            borderWidth:2,
                            borderColor: tabSelected.includes(2) ? bc9 : 'white',
                        }}
                        type='primary'
                    > 
                        <div style={{display:  'flex', flex: 2, alignItems: 'center', justifyContent: 'flex-end'}}>
                            {displayMessage("EXERCISES")}
                        </div>
                        <div style={{display:  'flex', flex: 1, alignItems: 'center', justifyContent: 'flex-end'}}>
                            { tabSelected.includes(2) ? <UpOutlined/> : <DownOutlined />}
                        </div>
                    </Button>
                </div>
                <div style={{display: 'flex', flex:1, padding: 10, flexDirection: 'column', maxHeight: 270, overflow: 'auto'}}>
                    {  (tabSelected.includes(1)  && !tabIsLoading) &&
                        controls.map((e, index) => (
                            <div key={e?.id} style={{color: 'white', display: 'flex', flex: 1, flexDirection: 'column'}}>
                                <div key={e?.id} style={{color: 'white', display: 'flex', flex: mobile_mode ? 0 : 1, flexDirection: 'row', alignItems: 'center'}}>
                                    <Tooltip title={displayMessage('CONTROL_DATE_TOOLTIP')}>
                                        <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                            {e?.control_day ? DateTime.fromISO(e?.control_day).toUTC().toFormat(mobile_mode ? "dd/MM/yy" : "dd/MM/yyyy") : displayMessage('NOT_INFORMED2')}
                                        </div>
                                    </Tooltip>
                                        {
                                            e.day_missed > 0 &&
                                            <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3}}>
                                                <Tooltip title={displayMessage('MISSING_DAY_TOOLTIP')}>
                                                    <CloseCircleOutlined style={{fontSize: 20, color: 'red'}}/>
                                                </Tooltip>
                                            </div>
                                        }
                                        {
                                            !e.day_missed && e.missing_sync &&
                                            <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3}}>
                                                <Tooltip title={displayMessage('MISSING_SYNC_TOOLTIP')}>
                                                    <ExclamationCircleOutlined style={{fontSize: 20, color: 'yellow'}}/>
                                                </Tooltip>
                                            </div>
                                        }
                                        {
                                            !e.day_missed && !e.missing_sync &&
                                            <Tooltip title={displayMessage('MIN_DURATION_TOOLTIP')}>
                                                <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3}}>
                                                    <CloackIcon width={20} height={20} fill={'white'} />
                                                  {((e?.duration_formatted / 60).toFixed(0) === '0') ?
                                                      (`${Math.round(e?.duration_formatted)} ${mobile_mode ? '' : 's.'}`) :
                                                      (`${(e?.duration_formatted / 60).toFixed(0)} ${mobile_mode ? '' : 'min.'}`)
                                                  }
                                                </div>
                                            </Tooltip>
                                        }
                                    {/* <Tooltip title={displayMessage('STAR_SCORE_TOOLTIP')}>
                                        <div style={{flex: 1, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', gap: 3}}>
                                            <ChartIcon width={18} height={18} fill={'white'} />
                                            {`${(e?.avg_monitory_stars && e.avg_monitory_stars != displayMessage('NOT_INFORMED2')) ? e?.avg_monitory_stars : 0}${mobile_mode ? '%' : '/100'}`}
                                        </div>
                                    </Tooltip> */}
                                    <Tooltip title={displayMessage('PATIENT_RATING_TOOLTIP')}>
                                        <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3}}>
                                            <PersonIcon width={18} height={18} fill={'white'} />
                                            <ColorScore color_scores={color_scores} score={(Math.floor(e?.avg_monitory_rating))}  is_emoji={true}/>
                                        </div>
                                    </Tooltip>
                                    <Tooltip title={displayMessage('PATIENT_STAGE_TOOLTIP')}> 
                                        <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3}}>
                                            <RobotIcon width={20} height={20} fill={'white'} />
                                            <ColorScore color_scores={color_scores} score={(Math.floor(e?.avg_monitory_stage))} />
                                        </div>
                                    </Tooltip>
                                    <Tooltip title={displayMessage('MANGOS_TOOLTIP')}> 
                                        <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3}}>
                                            <MangosIcon width={18} height={18} fill={'white'} />
                                            {e?.new_version_monitory_mangos ? e.new_version_monitory_mangos : 0}
                                        </div>
                                    </Tooltip>
                                    <Tooltip title={displayMessage('DETAIL_TOOLTIP')}>
                                            <Button type='text' onClick={()=>{handleOnOpenModalDetail(false, e?.id)}} style={{maxWidth: 24, display: 'flex', padding: 0, alignItems: 'center'}}>
                                                <PlusIcon width={20} height={20} fill={'white'}/>
                                            </Button>
                                    </Tooltip>
                                </div>
                                {index < controls.length - 1 && <hr style={{ width: '100%', borderColor: 'white', margin: '10px 0', borderWidth: '1px' }} />}
                            </div>
                        ))
                    } {
                        (tabSelected.includes(2) && !tabIsLoading) &&
                        controls.map((e, index) => (
                            <div key={e?.id} style={{color: 'white', display: 'flex', flex: 1, flexDirection: 'column'}}>
                                    <div key={e?.id} style={{color: 'white', display: 'flex', flex: 1, flexDirection: 'row'}}>
                                        <Tooltip title={displayMessage('CONTROL_DATE_TOOLTIP')}>
                                            <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                                {e?.control_day ? DateTime.fromISO(e?.control_day).toUTC().toFormat(mobile_mode ? "dd/MM/yy" : "dd/MM/yyyy") : displayMessage('NOT_INFORMED2')}
                                            </div>
                                        </Tooltip>
                                        <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3 }}>
                                            {
                                                e.is_exerciseless_weekend ? (
                                                <Tooltip title={displayMessage('IS_EXERCISELESS_WEEKEND')}>
                                                    <Block style={{ fontSize: 20, color: 'yellow' }} />
                                                </Tooltip>
                                                ) : e.exercise_day_missed ? (
                                                <Tooltip title={displayMessage('MISSING_DAY_TOOLTIP')}>
                                                    <CloseCircleOutlined style={{ fontSize: 20, color: 'red' }} />
                                                </Tooltip>
                                                ) : e.missing_exercise_sync ? (
                                                <Tooltip title={displayMessage('MISSING_SYNC_TOOLTIP')}>
                                                    <ExclamationCircleOutlined style={{ fontSize: 20, color: 'yellow' }} />
                                                </Tooltip>
                                                ) : (
                                                <Tooltip title={displayMessage('PATIENT_RATING_TOOLTIP')}>
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3 }}>
                                                    <PersonIcon width={18} height={18} fill="white" />
                                                    <ColorScore
                                                        color_scores={color_scores}
                                                        score={Math.floor(e?.avg_exercise_rating)}
                                                        is_emoji={true}
                                                    />
                                                    </div>
                                                </Tooltip>
                                                )
                                            }
                                        </div>

                                        <Tooltip title={displayMessage('PATIENT_STAGE_TOOLTIP')}>
                                            <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3}}>
                                                <RobotIcon width={20} height={20} fill={'white'} />
                                                <ColorScore color_scores={color_scores} score={e?.avg_exercise_stars} is_start={true}/>
                                            </div>
                                        </Tooltip>
                                        <Tooltip title={displayMessage('MANGOS_TOOLTIP')}> 
                                            <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3}}>
                                                <MangosIcon width={20} height={20} fill={'white'} />
                                                {e?.new_version_exercise_mangos ? e.new_version_exercise_mangos : 0}
                                            </div>
                                        </Tooltip>
                                        <Tooltip title={displayMessage('DETAIL_TOOLTIP')}>
                                                <Button type='text' onClick={()=>{handleOnOpenModalDetail(true, e?.id)}} style={{maxWidth: 24, display: 'flex', padding: 0, alignItems: 'center'}}>
                                                    <PlusIcon width={20} height={20} fill={'white'}/>
                                                </Button>
                                        </Tooltip>
                                    </div>

                                {index < controls.length - 1 && <hr style={{ width: '100%', borderColor: 'white', margin: '10px 0', borderWidth: '1px' }} />}
                            </div>
                        ))
                    } {
                        tabIsLoading &&
                        <div key={9999} style={{color: 'white', display: 'flex', flex: 1, flexDirection: 'column'}}>
                            <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
                        </div>
                    }
                </div>
            </div>
        </div>)
    })
    const handleOnOpenModalFilter = () => {
        setIsFilterModalOpen(true)
    }
    const handleOnCloseModalFilter = () => {
        setIsFilterModalOpen(false)
    }
    const handleOnOpenModalDetail = async (is_exercise_tab, selectedControlId) => {
        setShowLoading(true)
        try {
            setDetailModalShowExercise(is_exercise_tab)
            setIsControlDetailModalOpen(true)
            let res = await api.control.findControl(selectedControlId)
            setMonitoryEvents(res.data?.monitoryEvents)
            setExerciseEvents(res.data?.exerciseEvents)

            setExerciseSections(res.data?.exerciseSections)
            setMonitorySections(res.data?.monitorySections)
        } catch (error) {
            console.log(error)
        } finally {
            setShowLoading(false)
        }
    }
    const handleOnCloseModalDetail = () => {
        setIsControlDetailModalOpen(false)
        setMonitoryEvents([])
        setExerciseEvents([])
    }

    return (
        <>
            {
                isFilterModalOpen &&
                <ListControlFilters
                    isModalVisible={isFilterModalOpen}
                    handleOnCloseModal={handleOnCloseModalFilter}
                    loadControlsData={loadControlsData}
                    handleScrollToFirstControl={handleScrollToFirstControl}
                    currentFilters={currentFilters}
                    setCurrentFilters={setCurrentFilters}
                />
            }
            {
                isControlDetailModalOpen &&
                <ListControlDetailModal
                    isModalVisible={isControlDetailModalOpen}
                    handleOnCloseModal={handleOnCloseModalDetail}
                    detailModalShowExercise = {detailModalShowExercise}
                    monitoryEvents = {monitoryEvents}
                    exerciseEvents = {exerciseEvents}
                    exerciseSections = {exerciseSections}
                    monitorySections = {monitorySections}
                />
            }

            <div className='flex flex-col w-full h-full'>

                <div style={{ flex: 1, minHeight: 300, display: 'flex', flexDirection: 'column', width: '100%'}} >

                    <div style={{display: 'flex', flex: 1, padding: 2, gap: '2px', flexDirection: 'row', maxHeight: 40, marginBottom: 0}}>
                        <span style={{fontWeight: 'bold', display: 'flex', flex: 1, justifyItems: 'flex-start', alignItems: 'center', fontSize: 20}}>
                            {displayMessage('CONTROLS_HISTORY')}
                        </span>
                        <Button
                            type='default'
                            style={{ display: 'flex', alignItems: 'center', borderRadius: '20px', color: 'white', backgroundColor: bc9, marginLeft: 2, marginRight: 2, gap: 5}}
                            onClick={handleOnOpenModalFilter}
                        >
                            <FilterIcon width={14} height={14} fill={'white'} />
                            {displayMessage('FILTERS')}
                        </Button>
                    </div>

                    <div style={{display: 'flex', padding: 2, flexDirection: 'column', boxShadow: '0px 4px 2px rgba(10, 10, 10, 0.25)'}}>
                        <div className='flex flex-1 flex-row gap-2'>
                            <span style={{fontWeight: 'bold', display: 'flex', justifyItems: 'flex-start', alignItems: 'center'}}>
                                {displayMessage('BETWEEN_DAYS', [currentFilters?.start_date, currentFilters?.end_date])}
                            </span>
                            <span style={{fontWeight: 'normal', display: 'flex', justifyItems: 'flex-start', alignItems: 'center'}}>
                                {currentFilters?.start_date ? DateTime.fromISO(currentFilters?.start_date).toFormat("dd/MM/yyyy") : ""}
                            </span>
                            <span style={{fontWeight: 'normal', display: 'flex', justifyItems: 'flex-start', alignItems: 'center'}}>
                                {` - `}
                            </span>
                            <span style={{fontWeight: 'normal', display: 'flex', justifyItems: 'flex-start', alignItems: 'center'}}>
                                {currentFilters?.end_date ? DateTime.fromISO(currentFilters?.end_date).toFormat("dd/MM/yyyy") : ""}
                            </span>
                        </div>
                        <div className='flex flex-1 flex-row gap-2'>
                            <span style={{fontWeight: 'bold', display: 'flex', justifyItems: 'flex-start', alignItems: 'center'}}>
                                {displayMessage('ORDER_BY')+":"}
                            </span>
                            <div 
                                style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 5, padding: '10px 0px'}} 
                                onClick={()=>{
                                    const nextFrequency = !orderByFrequency
                                    setOrderByScore(false)
                                    setOrderByFrequency(nextFrequency)
                                    // Atualiza refs imediatamente (setState é assíncrono) e recarrega do início
                                    orderByFrequencyRef.current = nextFrequency
                                    orderByScoreRef.current = false
                                    handleScrollToFirstControl({is_auto: true})
                                    loadControlsData({ by_frequency: nextFrequency, by_score: false }, false)
                                }}
                            >
                                { orderByFrequency ? <CheckedIcon width={14} height={14} fill={bc9}/> : <UnCheckedIcon width={14} height={14} fill={bc9}/> }
                                {displayMessage("FREQUENCY")}
                            </div>
                            <div 
                                style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 5}} 
                                onClick={()=>{
                                    const nextScore = !orderByScore
                                    setOrderByScore(nextScore)
                                    setOrderByFrequency(false)
                                    // Atualiza refs imediatamente (setState é assíncrono) e recarrega do início
                                    orderByScoreRef.current = nextScore
                                    orderByFrequencyRef.current = false
                                    handleScrollToFirstControl({is_auto: true})
                                    loadControlsData({ by_frequency: false, by_score: nextScore }, false)
                                }}>
                                { orderByScore ? <CheckedIcon width={14} height={14} fill={bc9}/> : <UnCheckedIcon width={14} height={14} fill={bc9}/> }
                                {displayMessage("PERFORMANCE")}
                            </div>
                        </div>
                    </div>

                    {
                        controlsGroups && controlsGroups?.length > 0 ?
                        <div style={{display: 'flex', width: '100%', justifyContent: 'center', overflow: 'auto', alignItems: 'flex-start'}}>
                            <div style={{display: 'flex', gap: mobile_mode ? 20 : 30, flexDirection: 'row', marginTop: 5, padding: '10px 5px', flexWrap: 'wrap', width: '100%'}}>
                            {controlsGroups && controlsGroups.length > 0 ? (
                                <div style={{ display: 'flex', width: '100%', justifyContent: 'center', overflow: 'auto', alignItems: 'flex-start' }}>
                                    <div style={{ display: 'flex', gap: mobile_mode ? 20 : 30, flexDirection: 'row', marginTop: 5, padding: '10px 5px', flexWrap: 'wrap', width: '100%', justifyContent: 'center' }}>
                                        {controlsGroups.map((control, index) => (
                                            <ControlCard
                                                key={index}
                                                info={control}
                                                ref={index === 0 ? firstControlRef : index === controlsGroups.length - 1 ? lastControlRef : null} // Assign ref to first and last items
                                            />
                                        ))}
                                    </div>
                                </div>
                            ) : null}
                            </div>
                        </div>
                        :
                        null
                    }
                </div>
                {/* <button onClick={handleScrollToLastControl}>{displayMessage("LAST_CONTROL")}</button>
                <button onClick={handleScrollToFirstControl}>{displayMessage("FIRST_CONTROL")}</button> */}
            </div>
        </>
    )
}
